import { render, staticRenderFns } from "./StyleDialogLabelsPreview.vue?vue&type=template&id=56f75bfc&scoped=true&"
import script from "./StyleDialogLabelsPreview.vue?vue&type=script&lang=js&"
export * from "./StyleDialogLabelsPreview.vue?vue&type=script&lang=js&"
import style0 from "./StyleDialogLabelsPreview.vue?vue&type=style&index=0&id=56f75bfc&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "56f75bfc",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VCol } from 'vuetify/lib/components/VGrid';
import { VRow } from 'vuetify/lib/components/VGrid';
installComponents(component, {VCol,VRow})
